import { Lumber } from '@paragon/contract-library';

export const getNominalBoardFeet = (lumber: Lumber, length: number) =>
  (parseFloat(lumber.nominalThickness) * parseFloat(lumber.nominalWidth) * length) / 144;
